import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormStorageService } from '../../services/form-storage.service';
import { UploadPurchaseOrderModal } from '../../components/purchase-order/upload-purchase-order-modal/upload-purchase-order-modal.component';

interface purchaceOrder {
  fileName: string;
  fileStatus?: string;
}

@Component({
  selector: 'app-purchase-page',
  imports: [NgIf, CommonModule, UploadPurchaseOrderModal],
  templateUrl: './purchase-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PurchasePageComponent { 
  orders: purchaceOrder[] = [];
  showModal = false;
  showBarcodeModal = false;

  private readonly STORAGE_KEY = 'orderDocs';

  constructor( 
    private formStorage: FormStorageService){}

  ngOnInit(): void {
    const savedOrders = this.formStorage.load<purchaceOrder[]>(this.STORAGE_KEY);
    if (savedOrders) {
      this.orders = savedOrders;
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }


  handleFilesUpload(file: File) {
    const status = 'Cargada';
    const newPurchaseOrder = {
      fileName: file.name,
      fileStatus: status
    };

    this.orders.push(newPurchaseOrder);
    this.formStorage.save(this.STORAGE_KEY, this.orders);
  }
}
